import { getGradingCompanies } from "@/api/grading";
import { useQuery } from "@tanstack/react-query";

export function useGradingCompanies() {
  return useQuery({
    queryKey: ["grading-companies"],
    queryFn: getGradingCompanies,
  });
}
